import React from "react";
import styled from "styled-components";
import colors from "../../utils/constants/COLORS";

const Checkbox = ({ label, checked, onChange }) => {
  return (
    <Container onClick={onChange}>
      <Box>
        <BoxInner checked={checked} stroke={checked ? "#2C6ECB" : "#8C9196"}>
          {checked && <CheckMark />}
        </BoxInner>
      </Box>
      <div>{label}</div>
    </Container>
  );
};

const Container = styled.div`
  color: ${colors.primary};
  cursor: pointer;

  display: flex;
  align-items: center;

  font-size: 14px;
  font-weight: 500;
  line-height: 20px;

  padding: 0.25rem 0;

  user-select: none;

  width: max-content;
`;

const Box = styled.div`
  border-radius: 5px;

  height: 20px;
  width: 20px;

  margin-right: 0.5rem;

  &:focus {
    border-color: #2c6ecb;
  }
`;

const BoxInner = styled.div`
  background-color: ${(props) => (props.checked ? "#2C6ECB" : "transparent")};
  border: 2px solid ${(props) => props.stroke};
  border-radius: 4px;

  display: flex;
  align-items: center;
  justify-content: center;

  height: calc(100% - 2px);
  width: calc(100% - 2px);
`;

const CheckMark = () => {
  return (
    <svg
      width="10"
      height="8"
      viewBox="0 0 10 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.31476 7.858L0.132954 4.441C-0.044318 4.253 -0.044318 3.947 0.132954 3.757L0.775678 3.074C0.95295 2.886 1.24113 2.886 1.4184 3.074L3.63657 5.466L8.5811 0.141C8.75837 -0.047 9.04655 -0.047 9.22382 0.141L9.86655 0.825C10.0438 1.013 10.0438 1.32 9.86655 1.507L3.95748 7.858C3.78021 8.046 3.49203 8.046 3.31476 7.858Z"
        fill="white"
      />
    </svg>
  );
};

export default Checkbox;
